import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

export const doctorGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isDoctor()) {
    return true;
  }

  return router.parseUrl('/calendario-rentas');
};
